<template>
  <div class="infoForm" v-loading="loading">
    <div class="statusDiv" v-if="(isEdit || readOnly) && !isMerchant">
      <span :class="statusColor" class="status"><i class="el-icon-warning-outline"></i>{{ form.statusDesc }}</span>
      <!--              审核失败时，显示原因-->
      <span class="reviewTime" v-if="form.statusDesc === '审核不通过'">退回原因：{{ remark }}</span>
    </div>
    <el-collapse v-model="collapseList">
      <el-card shadow="never">
        <el-collapse-item name="account">
          <template slot="title">
            <h2>商户注册信息
              <ViewAccount
                v-show="(isEdit || readOnly) && !isMerchant"
                @success="(account)=>{
                  this.form.username = account.fUserName
                  this.form.mobile = account.fMobile
                  this.businessForm.legalName =account.fApplicant
                  this.businessForm.servicePhone = account.fServicePhone
                  this.bankForm.holder = account.fBankHolder
                  this.bankForm.bankCardNo = account.fBankAccount
                }"
                :merchantId="id"
                :isReset="false"
                :showViewBtn="ifHide"
              />
            </h2>
          </template>
          <el-divider/>
          <el-form
            label-width="120px"
            ref="accountForm"
            label-position="left"
            :model="form"
            :rules="rule_data">
            <el-form-item label="退回原因" prop="fNopassReason" class="red" v-if="(isEdit || readOnly) && form.fNopassReason">
              <el-input v-model="form.fNopassReason" style="width: 50%" disabled></el-input>
            </el-form-item>
            <el-form-item label="店铺类型">
              <el-select
                style="width:120px;"
                :disabled="isEdit || readOnly"
                filterable
                placeholder="店铺类型"
                v-model="form.shopType"
                @change="changeShopType">
                <el-option label="总店" :value="1" ></el-option>
                <el-option label="分店" :value="0" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="总店商户编号"
              v-show="headShopMerchantIdInput"
              :rules="{ required: headShopMerchantIdInput, message: '请输入总店编号', trigger: 'blur' }"
              :error="headShopMerchantIdError">
              <el-input class="form-input" :disabled="readOnly" v-model="form.headMerchantId" placeholder="总店商户编号" @blur="handleHeadShopMerchantIdBlur"></el-input>
            </el-form-item>
            <el-form-item label="登录账号" prop="username" :error="userNameItemError">
              <el-input
                class="form-input"
                :disabled="isEdit || readOnly"
                v-model="form.username"
                placeholder="建议使用手机号，支持8~20位数字/字母"
                prop="username"
                @blur="checkUserName"></el-input>
              <span class="check-username-loading-view" v-show="checkLoading">
                <i class="el-icon-loading"></i>
                <span>检测中...</span>
              </span>
            </el-form-item>
            <el-form-item label="登录密码" prop="password" v-if="!readOnly && !isEdit">
              <el-input class="form-input" v-model="form.password" placeholder="8-20位大写/小写字母/数字/符号中的至少三种组合" ></el-input>
            </el-form-item>
            <el-form-item label="注册手机" prop="mobile" class="mobile">
              <el-input class="form-input" :disabled="readOnly" v-model="form.mobile" placeholder="11位正确手机号，用户登录账号密码找回"></el-input>
              <ChangePhone
                v-if="(isEdit || readOnly) && !isMerchant"
                :merchantId="id"
                :fAgentId="fAgentId.toString()"
                @updateInit="getNewMobile"
                @change="(newPhone)=>{form.mobile = newPhone}"
              />
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-card>
      <el-card shadow="never">
        <el-collapse-item name="business">
          <template slot="title">
            <h2>商户入网信息</h2>
          </template>
          <el-divider/>
          <label class="form-tip-label">注：投资类、理财类、棋牌类商户禁止入网</label><br><br>
          <el-form label-width="120px" label-position="left">
            <el-form-item label="商户信息" v-show="headShopMerchantIdInput && !isEdit && !readOnly">
              <el-select filterable v-model="businessInfoFlag" @change="businessInfoMethod">
                <el-option label="与总店一致" :value="1" ></el-option>
                <el-option label="与总店不一致" :value="0" ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form
            label-width="120px"
            ref="businessForm"
            label-position="left"
            :model="businessForm"
            :rules="rule_data"
            :disabled="readOnly">
            <el-form-item label="商户类型" prop="realMerchantType">
              <el-select v-model="businessForm.realMerchantType" @change="wxMchTypeChange" :disabled="passed || businessEditable">
                <el-option :value="1" label="小微商户"></el-option>
                <el-option :value="2" label="个体商户"></el-option>
                <el-option :value="3" label="企业商户"></el-option>
                <el-option :value="4" label="事业单位"></el-option>
                <el-option :value="6" label="集团总公司"></el-option>
                <el-option :value="7" label="集团分公司"></el-option>
                <el-option :value="5" label="其他组织"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商户全称" prop="merchantName">
              <el-input
                class="form-input"
                v-model="businessForm.merchantName"
                :disabled="passed || businessEditable || businessForm.merchantType !== 1"
                type="textarea"
                :rows="2"
                resize="none"
                placeholder="2-40个字，与营业执照名称一致；若为小微商户，应填“商户_XXX”，XXX为小微商户身份证上的姓名"></el-input>
            </el-form-item>
            <el-form-item label="商户简称" prop="merchantShortName">
              <el-input class="form-input" v-model="businessForm.merchantShortName" placeholder="商户简称，2~30个字，不能为纯数字，不能包含敏感词汇"></el-input>
            </el-form-item>
            <el-form-item label="企业证件类型" v-if="businessForm.merchantType !== 1">
              <el-select v-model="businessForm.licenseType" :disabled="passed || businessEditable" @change="$refs.businessForm.clearValidate('license')">
                <el-option :value="0" label="营业执照"></el-option>
                <el-option :value="1" label="特殊行业许可证"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="营业执照证照" prop="licensePic" :required="!businessForm.licenseFlag && !businessEditable">
              <ocr-recognition
                type="10"
                :disabled="businessEditable || businessForm.licenseFlag || readOnly"
                :required="!businessForm.licenseFlag"
                :value="businessForm.licensePic"
                valueName="businessForm.licensePic"
                @submit="getOCRResult"
                :to-check="needOcr && !businessEditable && !passed"></ocr-recognition>
              <el-checkbox v-model="businessForm.licenseFlag" :disabled="businessForm.merchantType !== 1 || businessEditable" style="width:150px;margin-left: 15px;vertical-align: bottom;" @change="resetLicense">暂无营业执照</el-checkbox>
            </el-form-item>
            <el-form-item
              label="营业执照名称"
              prop="licenseFullName"
              :rules="{
                required: !businessForm.licenseFlag && !businessEditable,
                message:'请输入2~40位营业执照名称',
                trigger: 'blur'}">
              <el-input
                class="form-input"
                v-model="businessForm.licenseFullName"
                :disabled="businessForm.licenseFlag || passed || businessEditable"
                type="textarea"
                :rows="3"
                resize="none"
                placeholder="2-40个字，与商户全称一致，若营业执照无商家名称或名称为“*”或“***”，则应填“个体户XXX”，XXX为营业执照上经营者姓名"
                @blur="getLicenseInput"></el-input>
            </el-form-item>
            <el-form-item label="营业执照编号" prop="license">
              <el-input class="form-input" v-model.trim="businessForm.license" :disabled="businessForm.licenseFlag || passed || businessEditable" placeholder="营业执照注册号"></el-input>
              <!--                如果暂无营业执照，可以编辑-->
              <!--                <el-checkbox v-model="businessForm.licenseFlag" style="width:150px;margin-left: 15px;" @change="resetLicense" :disabled="haveLicenseFlag || businessEditable || businessForm.licenseFlag && isEdit">暂无营业执照</el-checkbox>-->
            </el-form-item>
            <expiry-date
              ref="licenseExpiryDate"
              label="营业执照有效期"
              label-width="122px"
              :value="licenseExpiryDate"
              valueName="license"
              :readOnly="businessEditable || businessForm.licenseFlag || readOnly"
              :required="!businessForm.licenseFlag && !businessEditable"
              @change="getExpiryDate"></expiry-date>
            <el-form-item label="法人证件类型" prop="credentialType" required>
              <el-select placeholder="请选择证件类型" v-model="businessForm.credentialType" @change="swiftCertType" :disabled="passed || businessForm.merchantType === 1 || businessEditable">
                <el-option label="身份证" :value="1"></el-option>
                <el-option label="港澳台通行证" :value="2"></el-option>
                <el-option label="台湾身份证" :value="3"></el-option>
                <el-option label="香港身份证" :value="4"></el-option>
                <el-option label="澳门身份证" :value="5"></el-option>
                <el-option label="护照" :value="6"></el-option>
                <el-option label="居住证" :value="7"></el-option>
                <el-option label="其他法定证件" :value="9"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="法人证件照" required>
              <el-row type="flex" class="flexRow">
                <el-form-item prop="idcardFrontPic">
                  <!--                            身份证可以ocr识别-->
                  <ocr-recognition
                    v-if="businessForm.credentialType === 1"
                    type="8"
                    :disabled="businessEditable|| readOnly"
                    label="证件照人像面"
                    :value="businessForm.idcardFrontPic"
                    valueName="businessForm.idcardFrontPic"
                    @submit="getOCRResult"
                    :to-check="needOcr && !businessEditable && !passed"></ocr-recognition>
                  <upload-img-ele
                    v-else
                    ref="idcardFrontPic"
                    valueName="businessForm.idcardFrontPic"
                    :value="businessForm.idcardFrontPic"
                    label="证件照人像面"
                    :disabled="businessEditable || readOnly"
                    @upload="uploadSuccess"></upload-img-ele>
                </el-form-item>
                <el-form-item prop="idcardBackPic" style="margin-left: 20px">
                  <!--                            身份证可以ocr识别-->
                  <ocr-recognition
                    v-if="businessForm.credentialType === 1"
                    type="7"
                    :disabled="businessEditable|| readOnly"
                    label="证件照国徽面"
                    :value="businessForm.idcardBackPic"
                    valueName="businessForm.idcardBackPic"
                    @submit="getOCRResult"
                    :to-check="needOcr && !businessEditable && !passed"></ocr-recognition>
                  <upload-img-ele
                    v-else
                    ref="idcardBackPic"
                    valueName="businessForm.idcardBackPic"
                    :value="businessForm.idcardBackPic"
                    label="证件照国徽面"
                    :disabled="businessEditable || readOnly"
                    @upload="uploadSuccess"></upload-img-ele>
                </el-form-item>
              </el-row>

            </el-form-item>
            <el-form-item label="法人姓名" prop="legalName">
              <el-input class="form-input" v-model="businessForm.legalName" placeholder="请输入法人姓名" :disabled="passed || businessEditable"></el-input>
            </el-form-item>
            <el-form-item label="法人证件号" prop="idCardNo">
              <el-input class="form-input" v-model="businessForm.idCardNo" :disabled="passed || businessEditable" :placeholder="credentialLabel.idCardHolder" @blur="publicBeneficial"></el-input>
            </el-form-item>
            <expiry-date
              ref="idCardExpiryDate"
              label="证件有效期"
              label-width="120px"
              :value="idCardExpiryDate"
              :read-only="readOnly || businessEditable"
              :required="form.statusDesc !== '审核通过' && !businessEditable"
              value-name="idCard"
              @change="getExpiryDate"></expiry-date>
            <el-form-item label="行业类型" required>
              <el-row type="flex">
                <el-form-item
                  prop="mccType"
                  class="form-flex-item"
                  :rules="{
                    required: !businessEditable,
                    message: '请选择全部行业',
                    trigger: 'blur'
                  }">
                  <el-select
                    style="width:200px;"
                    :disabled="passed || businessEditable"
                    placeholder="全部行业"
                    clearable
                    filterable
                    v-model="businessForm.mccType"
                    @change="getGroup">
                    <el-option v-for="item in mcc_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="mccMiddle"
                  class="form-flex-item"
                  :rules="{
                    required: !businessEditable,
                    message: '请选择行业小类',
                    trigger: 'blur'
                  }">
                  <el-select
                    style="width:200px;"
                    :disabled="passed || businessEditable"
                    placeholder="行业小类"
                    clearable
                    filterable
                    v-model="businessForm.mccMiddle"
                    @change="getMccDetails">
                    <el-option v-for="item in mccMiddle_list" :label="item.mccTxt" :value="item.mccCode" :key="item.mccCode"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="mccCode"
                  :rules="{
                    required: !businessEditable,
                    message: '请选择详细类别',
                    trigger: 'blur'
                  }">
                  <el-select
                    style="width:200px;"
                    :disabled="passed || businessEditable"
                    placeholder="请选择详细类别"
                    filterable
                    clearable
                    v-model="businessForm.mccCode">
                    <el-option
                      v-for="item in group_list"
                      :key="item.mccCode"
                      :label="item.mccTxt"
                      :value="item.mccCode" ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </el-form-item>

            <el-form-item label="经营地址" required>
              <address-select
                ref="addressSelectForm"
                :required="!businessEditable"
                v-model="businessAddress"
                :value="businessAddress"
                :readOnly="readOnly"
                @getValue="getAddress"
                @getAddressTxt="getaddresstxt"></address-select>
            </el-form-item>
            <el-form-item label="客服电话" prop="servicePhone">
              <el-input class="form-input" v-model="businessForm.servicePhone" placeholder="用于联系商家客服，不填默认为商户账号信息填写手机号"></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-card>
      <el-card shadow="never">
        <el-collapse-item name="bank">
          <template slot="title">
            <h2>商户结算信息</h2>
          </template>
          <el-divider/>
          <label class="form-tip-label">
            注：请保持银行卡信息(证件号码、开户名、卡号)的匹配性</label><br><br>
          <el-form
            label-width="120px"
            ref="bankForm"
            label-position="left"
            :model="bankForm"
            :rules="rule_data"
            :disabled="readOnly">
            <el-form-item label="结算对象" prop="settleTo" v-show="headShopMerchantIdInput">
              <el-select
                style="width:120px;"
                class="settleTo"
                placeholder="结算对象"
                clearable
                filterable
                v-model="bankForm.settleTo"
                :disabled="form.shopType === 2"
                @change="settleToMethod">
                <el-option label="结算给总店" :value="1" ></el-option>
                <el-option label="结算给分店" :value="0" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算对象" prop="settleTo" v-show="!headShopMerchantIdInput">
              <el-select style="width:200px;" v-model="bankForm.settleTo">
                <el-option label="独立结算" :value="0"></el-option>
                <el-option label="与下属分店合并结算" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算类型" required>
              <el-row type="flex">
                <el-form-item class="form-flex-item" prop="accountType">
                  <el-select
                    style="width: 120px;"
                    placeholder="账户类型"
                    filterable
                    v-model="bankForm.accountType"
                    @change="setAccType"
                    :disabled="settleToHead || businessForm.merchantType === 1">
                    <el-option label="对私账户" :value="1"></el-option>
                    <el-option label="对公账户" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="legalFlag" ref="formLegalFlagItem">
                  <el-select
                    style="width:120px;"
                    placeholder="结算类型"
                    filterable
                    v-model="bankForm.legalFlag"
                    @change="clearInfo"
                    :disabled="businessForm.merchantType === 1">
                    <el-option label="法人结算" :value="1"></el-option>
                    <el-option label="非法人结算" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <a href="static/非法人结算授权书.pdf" download v-if="!readOnly">
                  <div class="file-download-button">非法人结算授权书下载</div>
                </a>
              </el-row>
            </el-form-item>
            <div v-if="bankForm.legalFlag === 0">
              <el-form-item label="非法人授权书" prop="nonLegSettleAuthPic" required>
                <upload-img-ele
                  v-model="bankForm.nonLegSettleAuthPic"
                  :disabled="readOnly"
                  valueName="bankForm.nonLegSettleAuthPic"
                  :value="bankForm.nonLegSettleAuthPic"
                  @upload="uploadSuccess"></upload-img-ele>
              </el-form-item>
              <el-form-item label="非法人证件照" required>
                <el-row type="flex">
                  <el-form-item prop="nonLegIdcardFrontPic">
                    <ocr-recognition
                      type="8"
                      :disabled="readOnly"
                      label="身份证人像面"
                      valueName="bankForm.nonLegIdcardFrontPic"
                      :value="bankForm.nonLegIdcardFrontPic"
                      @submit="getOCRResult"
                      :to-check="needOcr"></ocr-recognition>
                  </el-form-item>
                  <el-form-item prop="nonLegIdcardBackPic" style="margin-left: 20px">
                    <ocr-recognition
                      type="7"
                      :disabled="readOnly"
                      label="身份证国徽面"
                      valueName="bankForm.nonLegIdcardBackPic"
                      :value="bankForm.nonLegIdcardBackPic"
                      @submit="getOCRResult"
                      :to-check="needOcr"></ocr-recognition>
                  </el-form-item>
                  <!-- <el-form-item prop="nonLegIdcardBackPic" style="margin-left: 20px">
                                        <upload-img-ele :disabled="readOnly" label="身份证国徽面"
                                                        :value="bankForm.nonLegIdcardBackPic" valueName="bankForm.nonLegIdcardBackPic" @upload="uploadSuccess"></upload-img-ele>
                                    </el-form-item> -->
                </el-row>
              </el-form-item>
            </div>
            <el-form-item :label="accountTypeLabel" prop="bankCardFrontPic" label-width="121px">
              <ocr-recognition
                type="9"
                :disabled="readOnly"
                :value="bankForm.bankCardFrontPic"
                v-if="bankForm.accountType === 1"
                valueName="bankForm.bankCardFrontPic"
                @submit="getOCRResult"
                :to-check="needOcr"></ocr-recognition>
              <upload-img-ele
                :disabled="readOnly"
                :value="bankForm.bankCardFrontPic"
                v-else
                valueName="bankForm.bankCardFrontPic"
                @upload="uploadSuccess"></upload-img-ele>
              <p v-if="bankForm.accountType === 2" class="form-tip-label">注：若无开户许可证，可用身份证，营业执照，结算确认书或其他图片进行代替</p>
            </el-form-item>
            <el-form-item label="开户名" prop="holder">
              <el-input class="form-input holder" v-model="bankForm.holder" :disabled="settleToHead" :placeholder="businessForm.merchantType === 3 || businessForm.merchantType === 2 && bankForm.accountType === 2? '与营业执照名称一致': '请填写结算人姓名'"></el-input>
            </el-form-item>
            <el-form-item id="bankCardNo" label="开户号" prop="bankCardNo">
              <el-input class="form-input" v-model="bankForm.bankCardNo" :disabled="settleToHead" :placeholder="bankForm.accountType === 2 ? '请填写开户许可证号' : '请填写结算人银行卡号或上传银行卡照片自动识别'" @blur="handleBankCardIdBlur"></el-input>
            </el-form-item>
            <el-form-item label="开户人证件号" prop="accountIdCardNo" v-show="bankForm.accountType !== 2">
              <el-input class="form-input accountIdCardNo" v-model="bankForm.accountIdCardNo" placeholder="上传身份证照自动识别或手动输入15/18位身份证号" :disabled="settleToHead" @blur="fillBeneficialInfo()">
                <el-select style="width:130px;" slot="prepend" placeholder="请选择证件类型" v-model="bankForm.bankIdCardType" disabled>
                  <el-option label="身份证" :value="1"></el-option>
                  <el-option label="港澳台通行证" :value="2"></el-option>
                  <el-option label="台湾身份证" :value="3"></el-option>
                  <el-option label="香港身份证" :value="4"></el-option>
                  <el-option label="澳门身份证" :value="5"></el-option>
                  <el-option label="护照" :value="6"></el-option>
                  <el-option label="居住证" :value="7"></el-option>
                  <el-option label="其他法定证件" :value="9"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <bank-branch
              label-width="120px"
              ref="bankBranchForm"
              :value="bankBranch"
              v-model="bankBranch"
              :bankCardId="lumhBankCardId"
              :readOnly="readOnly || settleToHead"
              @getValue="getBankBranch"
              @error="getBranchError"></bank-branch>
            <el-form-item label="预留号码" prop="accountMobile">
              <el-input class="form-input" v-model="bankForm.accountMobile" clearable :disabled="settleToHead" placeholder="开户号银行预留号码"></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-card>
      <el-card shadow="never" v-if="readOnly || isEdit">
        <!-- toDo -->
        <!-- 联系人信息 -->
        <el-collapse-item name="contact">
          <template slot="title">
            <h2>联系人信息</h2>
          </template>
          <el-divider/>
          <div class="contactItem"><span class="contactLabel">姓名</span>{{contactInfo.contactName}}</div>
          <div class="contactItem"><span class="contactLabel">身份证</span>{{contactInfo.contactIdCard}}</div>
          <div class="contactItem"><span class="contactLabel">手机号</span>{{contactInfo.contactPhoneNo}}</div>
        </el-collapse-item>
      </el-card>
      <el-card shadow="never">
        <!-- 受益所有人信息 -->
        <el-collapse-item name="beneficiary">
          <template slot="title">
            <h2>受益所有人信息</h2>
          </template>
          <el-divider/>
          <el-form
            label-width="120px"
            ref="beneficiaryForm"
            label-position="left"
            :model="beneficiaryForm"
            :rules="rule_data"
            :disabled="readOnly">
            <el-form-item label="姓名" prop="beneficiaryName">
              <el-input class="form-input" v-model="beneficiaryForm.beneficiaryName" placeholder="对公结算填法人姓名，对私结算填结算人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="法人证件类型" prop="beneficiaryCertificateNo">
              <el-input class="form-input accountIdCardNo" v-model="beneficiaryForm.beneficiaryCertificateNo" :placeholder="beneficiaryCarNumTxt" clearable>
                <el-select style="width:130px;" slot="prepend" placeholder="请选择证件类型" @change="swichCarType" v-model="beneficiaryForm.beneficiaryCertificateType">
                  <el-option label="身份证" :value="1"></el-option>
                  <el-option label="港澳台通行证" :value="2"></el-option>
                  <el-option label="台湾身份证" :value="3"></el-option>
                  <el-option label="香港身份证" :value="4"></el-option>
                  <el-option label="澳门身份证" :value="5"></el-option>
                  <el-option label="护照" :value="6"></el-option>
                  <el-option label="居住证" :value="7"></el-option>
                  <el-option label="其他法定证件" :value="9"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <expiry-date
              ref="beneficiaryExpiryDate"
              label="证件有效期"
              label-width="120px"
              :value="beneficiaryExpiryDate"
              :read-only="readOnly"
              value-name="beneficiaryValidity"
              @change="getBeneficiaryExpiryDate">
            </expiry-date>
            <el-form-item label="住所" prop="beneficiaryAddress">
              <el-input class="form-input" v-model="beneficiaryForm.beneficiaryAddress" placeholder="对公结算填法人证件地址，对私结算填结算人证件地址" clearable></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-card>
      <el-card shadow="never">
        <el-collapse-item name="other">
          <template slot="title">
            <h2>其他信息</h2>
          </template>
          <el-divider/>
          <el-form
            ref="otherForm"
            :model="form"
            :rules="rule_data"
            :disabled="readOnly"
            label-width="120px"
            label-position="left">
            <el-form-item label="通道类型">
              <el-select
                style="width:120px;"
                v-model="other.fPayType"
                placeholder="请选择"
                :disabled="passed || notPassed"
                @change="handlePayTypeSelectChange">
                <el-option label="线下业务" :value="2"></el-option>
                <el-option label="线上业务" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="渠道商名称"
              v-show="other.fPayType === 1 && !readOnly && !isEdit"
              :rules="{
                required: other.fPayType === 1,
                message: '请选择渠道商名称',
                trigger: 'change' }">
              <el-select
                v-model="form.reportConfigId"
                style="margin-right: 10px"
                clearable
                filterable
                :loading="selectLoading"
                :disabled="passed || notPassed"
                placeholder="请选择渠道商名称"
                @focus="handleAgentChannelSelectFocus"
                @change="handleAgentChannelSelectChange">
                <el-option
                  v-for="item in agentChannelList"
                  :key="item.fId"
                  :label="item.fChannelName"
                  :value="item.fId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="微信_商户全称" prop="wxMchName" v-show="form.shopType === 0">
              <el-input v-model="form.wxMchName" class="form-input" :disabled="!isSelfSetWxInfo || passed || notPassed" placeholder="请填写与总店一致的商户全称，共用公众号支付"></el-input>
            </el-form-item>
            <el-form-item label="微信行业类目ID" prop="wxCategory">
              <el-input class="form-input" v-model="form.wxCategory" :disabled="passed || notPassed" placeholder="请填写微信行业类目ID"></el-input>
              <a href="https://pay.weixin.qq.com/wiki/doc/api/mch_bank.php?chapter=9_210&index=2" style="display: inline-block;" target="_blank">
                <div class="file-download-button">点击查看详细类目信息</div>
              </a>
            </el-form-item>
            <el-form-item label="交易通知地址" prop="notifyAddress">
              <el-input class="form-input" v-model="form.notifyAddress" :disabled="passed || notPassed" placeholder="若不填，默认为代理商交易通知地址"></el-input>
            </el-form-item>
            <el-form-item label="审核回调地址" prop="auditCallback">
              <el-input class="form-input" v-model="form.auditCallback" placeholder="若不填，默认为代理商审核回调地址"></el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-card>
      <el-card shadow="never">
        <el-collapse-item name="pic">
          <template slot="title">
            <h2>证照信息</h2>
          </template>
          <el-divider/>
          <el-form label-width="0" ref="picForm" :model="picForm" :rules="rule_data">
            <div class="photos-content-view">
              <el-form-item label="" prop="doorPic">
                <upload-img-ele
                  label="门头照"
                  v-model="picForm.doorPic"
                  :disabled="readOnly"
                  :value="picForm.doorPic"
                  valueName="picForm.doorPic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"
                  desc="（门头照片，招牌文字清晰可见）"></upload-img-ele>
              </el-form-item>
              <el-form-item label="" prop="cashierDeskPic">
                <upload-img-ele
                  label="收银台照"
                  v-model="picForm.cashierDeskPic"
                  :disabled="readOnly"
                  :value="picForm.cashierDeskPic"
                  valueName="picForm.cashierDeskPic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"
                  desc="（需包含：标准物料、扫码支付二维码、刷卡支付场景中的支付机具或扫码枪）"></upload-img-ele>
              </el-form-item>
              <el-form-item label="" prop="insidePic">
                <upload-img-ele
                  label="经营场所照"
                  v-model="picForm.insidePic"
                  :disabled="readOnly"
                  :value="picForm.insidePic"
                  valueName="picForm.insidePic"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"
                  desc="（店内照，请勿拍摄单一物品）"></upload-img-ele>
              </el-form-item>
              <el-form-item label="" prop="agreementPic">
                <upload-img-ele
                  v-model="picForm.agreementPic"
                  :disabled="readOnly"
                  :value="picForm.agreementPic"
                  valueName="picForm.agreementPic"
                  :required="false"
                  label="租赁协议或房产证明"
                  @upload="uploadSuccess"
                  iconType="el-icon-picture"
                  desc="（pos进件必传）"></upload-img-ele>
              </el-form-item>
            </div>
          </el-form>
        </el-collapse-item>
      </el-card>
      <el-card shadow="never">
        <el-collapse-item name="otherPic" >
          <template slot="title">
            <h2>其他补充资料</h2>
          </template>
          <multi-upload :value="picForm.otherPics" valueName="otherPics" :uploadedValue="picForm.otherPicsPath" :limit="20" @uploaded="multiUploaded" @delete="multiDelete" :disabled="readOnly || isMerchant"></multi-upload>
        </el-collapse-item>
      </el-card>
    </el-collapse>

    <el-button class="submitBtn" type="primary" @click="submit" :loading="submitLoading" v-if="!readOnly">{{ submitText }}</el-button>
  </div>
</template>

<script>
import qs from 'qs'
import addressSelect from '@/components/addressSelect'
import bankBranch from '@/components/bankBranch'
// import luhmCheck from '@/utils/luhmCheck.js'
import ViewAccount from '@/components/ViewAccount'
import ChangePhone from './changePhone'
import expiryDate from './expiryDate'
import ocrRecognition from '@/components/OCRRecognition'
import uploadImgEle from '@/components/upload/uploadImgEle'
import { hideBankCardNum, hideRealName, hidePhoneNum, hideIdCardNum } from '@/utils/hideSensitiveInfo.js'
import { getMcc, findBranch } from '@/api/global'
import { checkMerchantId, checkUsername, getMerchantInfo, getAvailableChannel } from '@/api/merchant'
import multiUpload from '@/components/upload/multiUpload'
import { validStrictPsd, strictPsdError } from '@/utils/validate.js'

export default {
  name: 'InfoForm',
  components: {
    addressSelect,
    bankBranch,
    ViewAccount,
    ChangePhone,
    expiryDate,
    ocrRecognition,
    uploadImgEle,
    multiUpload
  },
  props: {
    // 整个表单能否编辑，区分是否是查看页面
    readOnly: {
      type: Boolean,
      default: false
    },
    // 商户id
    id: {
      type: String,
      default: ''
    },
    // 是否是编辑页面，用来控制一些编辑时不可编辑项，例如店铺类型等
    isEdit: {
      type: Boolean,
      default: false
    },
    submitText: {
      type: String,
      default: '提交审核'
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    // 是否是商户版-商户信息
    isMerchant: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      refresh: false, // 是否刷新
      loading: false, // 初始化加载
      headShopMerchantIdInput: false, // 是否显示总店商户编号输入框
      headShopMerchantIdOld: '', // 保存原本的总店商户id
      headShopMerchantIdError: '', // 总店编号错误信息
      userNameItemError: '', // 登录账号错误信息
      checkLoading: false, // 登录账号校验加载
      // 法人证件类型联动信息
      credentialLabel: {
        idCardHolder: '请输入证件号码'
      },
      mcc_list: [], // 行业大类列表
      mccMiddle_list: [], // 行业小类列表
      group_list: [], // 行业详细类列表
      settleToHead: false, // 结算对象是否是总店，如果是总店，不可编辑联动信息
      selectLoading: true,
      agentChannelList: [], // 渠道商列表
      isSelfSetWxInfo: true, // 微信公众号支付是否自定义设置

      // 企业资料选择总店，信息回填
      form: {
        // 商户基本信息
        fNopassReason: '', // 退回原因
        shopType: 1, // 店铺类型
        headMerchantId: '', // 总店商户编号
        username: '', // 登录账号
        password: '', // 登录密码
        mobile: '', // 绑定手机
        notifyAddress: '', // 交易异步回调（通知）地址URL
        statusDesc: '', // 状态文本
        statusId: '', // 状态id
        // 其他设置
        reportConfigId: '', // 渠道商名称
        subscribeAppid: '', // 关注APPID
        subAppid: '', // 支付APPID
        publicsignalAuthorizationDirectory: '', // 授权目录
        wxMchName: '', // 微信_商户全称
        wxCategory: '', // 微信行业类目
        auditCallback: '', // 商户审核回调
        remark: ''// 退回原因
      },
      // 商户入网信息
      businessInfoFlag: 0, // 企业资料0分店1总店
      businessEditable: false, // 入网信息是否可编辑，总店不可编辑
      businessForm: {
        merchantType: '', // 商户类型
        merchantName: '', // 商户全称
        merchantShortName: '', // 商户简称
        licensePic: '', // 营业执照照片
        licenseFullName: '', // 营业执照名称
        license: '', // 营业执照号
        licenseStart: '', // 营业执照有效期
        licenseEnd: '',
        licenseFlag: false, // 是否有营业执照号
        legalName: '', // 法人姓名
        idCardNo: '', // 法人证件号
        idCardStart: '', // 证件有效期
        idCardEnd: '',
        credentialType: 1, // 法人证件类型
        mccType: '', // 行业大类
        mccMiddle: '', // 行业小类
        mccCode: '', // 行业详细类
        provinceCode: '', // 经营地址省
        cityCode: '', // 经营地址市
        areaCode: '', // 经营地址区
        address: '', // 经营地址详细
        servicePhone: '', // 客服电话

        idcardFrontPic: '', // 法人证件照正面
        idcardBackPic: '', // 法人证件照背面

        licenseType: 0, // 企业证件类型
        realMerchantType: ''
      },
      //    结算信息
      // legalFlagDisabled:false,//能否禁止编辑结算类型
      isBankCardIdLuhmChecked: false, // 开户号校验是否是正确的银行卡号
      bankForm: {
        settleTo: '', // 结算对象
        accountType: '', // 账户类型，1对私账户，2对公账户
        legalFlag: '', // 结算类型，0非法人，1法人
        holder: '', // 开户名
        bankCardNo: '', // 开户号
        bankIdCardType: 1, // 开户人证件类型
        accountIdCardNo: '', // 开户人证件
        FBankTypeCode: '', // 银行类型编码
        FBankAreaCode: '', // 银行网点省编码
        FBankCityCode: '', // 银行网点市编码
        unionpay: '', // 分行网点id
        accountMobile: '', // 预留号码
        nonLegSettleAuthPic: '', // 非法人授权书
        nonLegIdcardFrontPic: '', // 非法人身份证人像面
        nonLegIdcardBackPic: '', // 非法人身份证国徽面
        bankCardFrontPic: ''// 银行卡照片/开户许可证
      },
      lumhBankCardId: '', // 通过校验的银行卡号
      bankTypeError: false, // 银行名称是否正确、

      // 受益人所有信息
      beneficiaryForm: {
        beneficiaryName: '', // 受益人姓名
        beneficiaryCertificateType: 1, // 证件类型
        beneficiaryCertificateNo: '', // 证件号
        beneficiaryValidityStart: '', // 营业执照有效期beneficiaryValidityStart
        beneficiaryValidityEnd: '', // beneficiaryValidityEnd
        beneficiaryAddress: '' // 证件地址
      },
      beneficiaryCarNumTxt: '请输入15/18位身份证号码',
      adTxt: '',

      other: {
        fPayType: 2// 业务类型线下2线上1
      },
      picForm: {
        insidePic: '',
        doorPic: '',
        cashierDeskPic: '',
        agreementPic: '',
        otherPics: '',
        otherPicsPath: ''
      },
      rule_data: {
        username: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        password: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              return callback(new Error(strictPsdError))
            }
          },
          trigger: 'blur',
          required: true
        }],
        mobile: [{
          validator: (rule, value, callback) => {
            // eslint-disable-next-line no-mixed-operators
            if (!(/^\d{11,11}$/.test(value)) && (!value.includes('*') && this.isEdit || !this.isEdit)) {
              callback(new Error('请输入11位手机号码'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        notifyAddress: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }],
        wxMchName: [{
          validator: (rule, value, callback) => {
            if (value !== '' && !this.form.headMerchantId) {
              callback(new Error('请输入总店商户编号'))
            } else if (value !== '' && this.parentData && this.parentData.basic && this.parentData.basic.licenseFullName !== '' && value !== this.parentData.basic.licenseFullName) {
              callback(new Error('请填写与总店一致的商户全称'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        wxCategory: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }],
        auditCallback: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }],
        merchantName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入商户全称'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{2,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('商户全称为长度2~40的汉字或汉字与数字组合'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        merchantShortName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入商户简称'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{2,30}$/.test(value) || /[a-zA-Z]{2,30}$/.test(value)) {
                callback()
              } else {
                callback(new Error('商户简称为长度2~30的汉字英文或汉字英文与数字组合'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        legalName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入正确姓名'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/^\S{2,45}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2~45位法人姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        // 受益人姓名
        beneficiaryName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入正确姓名'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/^\S{2,45}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2~45位受益人姓名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        // 受益人证件号
        beneficiaryCertificateNo: [{
          validator: (rule, value, callback) => {
            const creType = this.beneficiaryForm.beneficiaryCertificateType
            if (value === '') {
              callback(new Error('请输入法人证件号码'))
            } else {
              if (creType === 2) {
                // eslint-disable-next-line no-useless-escape
                if (!((/^[HM]{1}([\d|\*]{10}|[\d|\*]{8})$/.test(value)) || (/^([\d|\*]{8}|[\d|\*]{10})$/.test(value)))) {
                  callback(new Error('通行证号码输入有误'))
                } else {
                  callback()
                }
              } else if (creType === 1) {
                // eslint-disable-next-line no-useless-escape
                if (!(/(^[\d|\*]{15}$)|(^[\d|\*]{18}$)|(^[\d|\*]{17}(\d|X|x)$)/.test(value))) {
                  callback(new Error('请输入15/18位身份证号'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        // 受益人地址
        beneficiaryAddress: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入详细地址'))
            } else if (!(/^\S*$/.test(value))) {
              callback(new Error('空格无效，请重新输入'))
            } else if (/(?!^\w+$)^.{5,40}$/.test(value)) {
              callback()
            } else {
              callback(new Error('请输入5位以上详细地址'))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        idCardNo: [{
          validator: (rule, value, callback) => {
            const credentialType = this.businessForm.credentialType
            if (value === '') {
              callback(new Error('请输入法人证件号码'))
            } else {
              if (credentialType === 2) {
                // eslint-disable-next-line no-useless-escape
                if (!((/^[HM]{1}([\d|\*]{10}|[\d|\*]{8})$/.test(value)) || (/^([\d|\*]{8}|[\d|\*]{10})$/.test(value)))) {
                  callback(new Error('通行证号码输入有误'))
                } else {
                  callback()
                }
              } else if (credentialType === 1) {
                // eslint-disable-next-line no-useless-escape
                if (!(/(^[\d|\*]{15}$)|(^[\d|\*]{18}$)|(^[\d|\*]{17}(\d|X|x)$)/.test(value))) {
                  callback(new Error('请输入15/18位身份证号'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        servicePhone: [{
          validator: (rule, value, callback) => {
            if (value.includes('-')) {
              callback(new Error('客服电话中不能带-'))
            } else if (!(/^\d{5,20}$/.test(value)) && value !== '' && !value.includes('*')) {
              callback(new Error('请输入正确的客服电话'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        settleTo: [{
          required: true,
          message: '请选择账户类型',
          trigger: 'change'
        }],
        accountType: [{
          required: true,
          message: '请选择结算对象',
          trigger: 'change'
        }],
        legalFlag: [{
          required: true,
          message: '请选择结算类型',
          trigger: 'change'
        }],
        holder: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入正确的开户名'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/^\S{2,45}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入2~45位开户名'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        bankCardNo: [{
          validator: (rule, value, callback) => {
            if (this.settleToHead) {
              callback()
              return
            }
            if (value === '') {
              callback(new Error(`${this.bankForm.accountType === 2 ? '请输入正确的开户许可证账号' : '请输入正确的个人银行卡号'}`))
            } else {
              if ((this.bankForm.accountType === 2 && /^\S{5,30}$/.test(value)) || (this.isEdit && value.includes('*'))) {
                callback()
                // } else if (this.bankForm.accountType !== 2 && /^\d{16,19}$/.test(value) && luhmCheck(this.bankForm.bankCardNo) || this.isEdit && value.includes('*')) {
              } else if ((this.bankForm.accountType !== 2 && /^\d{16,19}$/.test(value)) || (this.isEdit && value.includes('*'))) {
                callback()
              } else {
                callback(new Error(`${this.bankForm.accountType === 2 ? '请输入正确的开户许可证账号' : '请输入正确的个人银行卡号'}`))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        accountIdCardNo: [{
          validator: (rule, value, callback) => {
            if (value === '' && this.bankForm.accountType !== 2) {
              callback(new Error('请输入开户人证件号'))
            } else if (this.bankForm.accountType !== 2) {
              // eslint-disable-next-line no-useless-escape
              if (!(/(^[\d|\*]{15}$)|(^[\d|\*]{18}$)|(^[\d|\*]{17}(\d|X|x)$)/.test(value)) && this.bankForm.bankIdCardType === 1) {
                callback(new Error('请输入15/18位身份证号'))
              // eslint-disable-next-line no-useless-escape
              } else if (!((/^[HM]{1}([\d|\*]{10}|[\d|\*]{8})$/.test(value)) || (/^([\d|\*]{8}|[\d|\*]{10})$/.test(value))) && this.bankForm.bankIdCardType === 2) {
                callback(new Error('通行证号码输入有误'))
              } else {
                callback()
              }
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        accountMobile: [{
          required: false,
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const check = (/^(\d{3,4}-?)?\d{7,9}$/.test(value) || /^(((13[0-9]{1})|(15[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(16[0-9]{1})|(19[0-9]{1}))+\d{8})$/.test(value))
              if (!check && !this.settleToHead && !this.readOnly) {
                callback(new Error('请输入正确手机号或座机号'))
              } else {
                callback()
              }
            }
          },
          message: '请输入正确手机号或座机号',
          trigger: 'blur'
        }],
        // 以下是证照信息校验
        idcardFrontPic: [{
          required: true,
          message: '请上传法人证件照头像面',
          trigger: 'change'
        }],
        idcardBackPic: [{
          required: true,
          message: '请上传法人证件照国徽面',
          trigger: 'change'
        }],
        bankCardFrontPic: [{
          validator: (rule, value, callback) => {
            if (value === '' || value === undefined) {
              callback(new Error(this.bankForm.accountType !== 2 ? '请上传银行卡正面' : '请上传开户许可证'))
            } else {
              callback()
            }
          },
          trigger: 'change',
          required: true
        }],
        license: [{
          validator: (rule, value, callback) => {
            if (this.businessForm.licenseFlag || this.businessEditable) {
              callback()
            } else if ((value === '' || value === undefined)) {
              callback(new Error('请输入营业执照号'))
            } else {
              if (this.businessForm.licenseType === 0 && !(/(^[A-Za-z\d]{15}$)|(^[A-Za-z\d]{18}$)/.test(value))) {
                callback(new Error('请输入15/18位营业执照号'))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur'
        }],
        licensePic: [{
          validator: (rule, value, callback) => {
            if (!this.businessForm.licenseFlag && (value === '' || value === undefined)) {
              callback(new Error('请上传营业执照'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        doorPic: [{
          required: true,
          message: '请上传门头照',
          trigger: 'change'
        }],
        cashierDeskPic: [{
          required: true,
          message: '请上传收银台照',
          trigger: 'change'
        }],
        insidePic: [{
          required: true,
          message: '请上传经营场所照',
          trigger: 'change'
        }],
        nonLegSettleAuthPic: [{
          validator: (rule, value, callback) => {
            if (this.bankForm.legalFlag === 0 && (value === '' || value === undefined)) {
              callback(new Error('请上传非法人结算授权协议'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        nonLegIdcardFrontPic: [{
          validator: (rule, value, callback) => {
            if (this.bankForm.legalFlag === 0 && (value === '' || value === undefined)) {
              callback(new Error('请上传非法人身份证头像面'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        nonLegIdcardBackPic: [{
          validator: (rule, value, callback) => {
            if (this.bankForm.legalFlag === 0 && (value === '' || value === undefined)) {
              callback(new Error('请上传非法人身份证国徽面'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        merchantType: [{
          message: '请选择商户类型',
          trigger: 'change',
          required: true
        }]
      },
      // 日期选择器快捷键设置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      parentData: {}, // 进件加盟分店时，记录总店数据
      ifHide: false, // 是否隐藏部分信息
      fAgentId: '', // 代理商id
      licenseExpiryDate: {
        dateStart: '',
        dateEnd: '',
        longTermTag: false
      }, // 营业执照有效期
      idCardExpiryDate: {
        dateStart: '',
        dateEnd: '',
        longTermTag: false
      }, // 证件有效期
      beneficiaryExpiryDate: {
        dateStart: '',
        dateEnd: '',
        longTermTag: false
      }, // 受益人证件有效期
      collapseList: ['account', 'business', 'bank', 'contact', 'beneficiary', 'other', 'pic', 'otherPic'],
      // accountTypeLabel:'银行卡照片',
      needOcr: true, // 是否需要OCR查询
      notPassed: false, // 审核不通过
      passed: false, // 审核通过
      toFinish: false, // 资料待完善
      remark: false, // 审核退回原因
      contactInfo: {
        contactPhoneNo: '',
        contactIdCard: '',
        contactName: ''
      }
    }
  },
  computed: {
    // 经营地址
    businessAddress () {
      return {
        provinceCode: this.businessForm.provinceCode,
        cityCode: this.businessForm.cityCode,
        areaCode: this.businessForm.areaCode,
        address: this.businessForm.address
      }
    },
    bankBranch () {
      return {
        bankNameCode: this.bankForm.FBankTypeCode, // 银行类型编码
        bankCityCode: this.bankForm.FBankCityCode, // 银行网点市编码
        bankAreaCode: this.bankForm.FBankAreaCode, // 银行网点省编码
        bankBranchCode: this.bankForm.unionpay// 分行id
      }
    },
    statusColor () {
      const state = this.form.statusId
      let color
      switch (state) {
        case 1: {
          color = 'red'
          break
        }
        case 3: {
          color = 'green'
          break
        }
        default: {
          color = 'gray'
        }
      }
      return color
    },
    accountTypeLabel () {
      if (this.bankForm.accountType === 2) {
        return '开户许可证照片'
      } else {
        return '银行卡照片'
      }
    }
  },
  mounted () {
    switch (process.env.CUSTOM_ENV) {
      case 'test': {
        this.domain = 'http://t-baseweb.lszzg.com/'
        break
      }
      case 'pre': {
        this.domain = 'http://p-baseweb.lszzg.com/'
        break
      }
      default: {
        this.domain = 'https://baseweb.lszzg.com/'
      }
    }
    this.getMcc(1, 0)// 获取行业类型
    // 不是编辑页面且也不是查看，触发本地存储
    if (!this.isEdit && !this.readOnly) {
      // 读取本地存储数据
      this.getLocalStorageAddInfo()
      // 设置触发对应事件时进行本地存储
      this.setStoreOnEvent()
    } else {
      this.getDetailsInfo()
    }
  },
  watch: {
    'bankForm.legalFlag': function (val, oldVal) {
      // if(!this.readOnly && !this.legalFlagDisabled && this.needOcr){
      if (!this.readOnly && this.needOcr && !this.loading) {
        this.bankForm.nonLegSettleAuthPic = ''
        this.bankForm.nonLegIdcardFrontPic = ''
        this.bankForm.nonLegIdcardBackPic = ''
        if (val === 1) {
          this.bankForm.holder = this.businessForm.legalName
          this.bankForm.bankIdCardType = this.businessForm.credentialType
          this.bankForm.accountIdCardNo = this.businessForm.idCardNo
        } else {
          this.bankForm.holder = ''
          this.bankForm.bankIdCardType = 1
          this.bankForm.accountIdCardNo = ''
        }
      }
    },
    'businessForm.legalName': function (val) {
      if (this.bankForm.accountType === 1 && this.bankForm.legalFlag === 1 && !this.loading) {
        this.bankForm.holder = val
      }
    },
    'businessForm.credentialType': function (val) {
      if (this.bankForm.accountType === 1 && this.bankForm.legalFlag === 1 && !this.loading) {
        this.bankForm.bankIdCardType = val
      }
    },
    'businessForm.idCardNo': function (val) {
      if (this.bankForm.accountType === 1 && this.bankForm.legalFlag === 1 && !this.loading) {
        this.bankForm.accountIdCardNo = val
      }
    }
  },
  activated () {
    const that = this
    setTimeout(function () {
      if (that.id !== '') {
        that.getDetailsInfo()
      }
    }, 100)
  },
  methods: {
    /**
             * @description 经营地址选中回调
             * @param {Object} val 组件传的参数，经营地址数据
             */
    getAddress (val) {
      this.businessForm.provinceCode = val.provinceCode
      this.businessForm.cityCode = val.cityCode
      this.businessForm.areaCode = val.areaCode
      this.businessForm.address = val.address
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    /**
             * @description 银行分行选中回调
             * @param {Object} val 组件传的参数，分行选中数据
             */
    getBankBranch (val) {
      this.bankForm.FBankTypeCode = val.bankNameCode// 银行类型编码
      this.bankForm.FBankCityCode = val.bankCityCode// 银行类型编码
      this.bankForm.FBankAreaCode = val.bankAreaCode// 银行类型编码
      this.bankForm.unionpay = val.bankBranchCode// 分行id
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    /**
             * @description 银行分行联动银行错误回调
             * @param {Object} value 组件传的参数，银行名称是否错误
             */
    getBranchError (value) {
      this.bankTypeError = value
    },
    /**
             * @description 切换店铺类型
             * @param {Number} value 0分店，1总店
             */
    changeShopType (value) {
      if (value === 0) {
        this.headShopMerchantIdInput = true
      }
      // 总店，清空内容
      if (value === 1) {
        this.headShopMerchantIdInput = false
        this.form.headMerchantId = ''
        this.bankForm.settleTo = ''
        this.businessForm.merchantType = ''
        this.businessInfoMethod(0)
        this.settleToMethod(this.bankForm.settleTo)
      }
    },
    /**
             * @description 企业资料切换联动，选择总店时，查询使用总店的信息，否则清空数据
             * @param {Number} value 0分店，1总店
             */
    businessInfoMethod (value) {
      const that = this
      // 企业资料选择的是总店
      if (value === 1) {
        that.businessInfoFlag = 1
        that.$refs.businessForm.resetFields()
        // 如果总店编号能查询到数据
        console.log(this.parentData)
        if (JSON.stringify(this.parentData) !== '{}') {
          const basic = this.parentData.basic
          const pic = this.parentData.pics
          this.setBusinessForm(basic, pic)
        } else {
          this.businessInfoMethod(0)
          this.businessInfoFlag = 0
          that.$message({
            message: '总店商户不存在或信息获取失败，请核对并重试！',
            type: 'error'
          })
        }
        that.businessEditable = true
      } else {
        that.businessInfoFlag = 0
        that.businessEditable = false
        // 入网信息表单恢复到初始值
        that.businessForm = this.$options.data().businessForm
        that.licenseExpiryDate = that.$options.data().licenseExpiryDate
        that.idCardExpiryDate = that.$options.data().idCardExpiryDate
        // 如果企业资料是分店，而结算类型是总店，只能是非法人结算，需上传非法人图片
        if (that.bankForm.settleTo === 1) {
          that.bankForm.legalFlag = 0
        }
        setTimeout(function () {
          that.$refs.licenseExpiryDate.$refs.form.clearValidate()
          that.$refs.idCardExpiryDate.$refs.form.clearValidate()
          that.$refs.addressSelectForm.$refs.form.clearValidate()
        }, 100)
      }
    },
    /**
             * @description 重置营业执照的校验
             */
    resetLicense () {
      this.businessForm.license = ''
      this.businessForm.licensePic = ''
      this.businessForm.licenseFullName = ''
      this.businessForm.licenseStart = ''
      this.businessForm.licenseEnd = ''
      this.licenseExpiryDate = {
        dateStart: '',
        dateEnd: '',
        longTermTag: false
      }
      const that = this
      this.$refs.businessForm.clearValidate('license')
      setTimeout(function () { that.$refs.businessForm.clearValidate('licensePic') }, 1000)
      this.$refs.businessForm.clearValidate('licenseFullName')
      this.$refs.licenseExpiryDate.$refs.form.clearValidate('dateStart')
      this.$refs.licenseExpiryDate.$refs.form.clearValidate('dateEnd')
    },
    /**
             * @description 法人证件类型切换，法人证件号和图片都要置空
             * @param {Number} type 1身份证，2港澳通行证
             */
    swiftCertType (type) {
      if (type === 1) {
        this.credentialLabel.idCardHolder = '请输入15/18位身份证号码'
      } else if (type === 2) {
        this.merchantExcelName = ''
        this.credentialLabel.idCardHolder = '请输入HM开头加8或10位数字的通行证号码'
      } else {
        this.credentialLabel.idCardHolder = '请输入法人证件号码'
      }
      this.businessForm.idCardNo = ''
      this.businessForm.idcardFrontPic = ''
      this.businessForm.idcardBackPic = ''
      this.$refs.businessForm.clearValidate('idCardNo')
      if (this.bankForm.legalFlag === 1) {
        this.bankForm.bankIdCardType = this.businessForm.credentialType
      } else {
        this.bankForm.bankIdCardType = 1
      }
    },
    /**
             * @description 受益人证件类型切换
             * @param {Number} type 1身份证，2港澳通行证
             */
    swichCarType (type) {
      console.log(type)
      if (type === 1) {
        this.beneficiaryCarNumTxt = '请输入15/18位身份证号码'
      } else if (type === 2) {
        this.beneficiaryCarNumTxt = '请输入HM开头加8或10位数字的通行证号码'
      } else {
        this.beneficiaryCarNumTxt = '对公结算填法人证件号，对私结算填结算人证件号'
      }
    },
    /**
             * @description 选中行业大类后获取行业小类列表
             * @param {Number} id 选中的大类id
             */
    getGroup (id) {
      if (id) {
        this.getMcc(2, id)
        this.businessForm.mccMiddle = ''
        this.businessForm.mccCode = ''
      }
    },
    /**
             * @description 选中行业小类后获取行业详细类别列表
             * @param {Number} id 选中的小类id
             */
    getMccDetails (id) {
      if (id) {
        this.getMcc(3, id)
        this.businessForm.mccCode = ''
      }
    },
    /**
             * @description 行业大类和小类的列表获取
             */
    getMcc (level, id) {
      let params = {
        level: level
      }
      let listKey = ''
      if (level === 3 && id !== 0) {
        params.fatherCode = id
        this.businessForm.mccCode = ''
        listKey = 'group_list'
      } else if (level === 2 && id !== 0) {
        params.fatherCode = id
        this.businessForm.mccMiddle = ''
        listKey = 'mccMiddle_list'
      } else {
        listKey = 'mcc_list'
      }
      this[listKey] = []
      params = qs.stringify(params)
      getMcc(params).then(data => {
        if (data.result_cde === '0') {
          this[listKey] = data.data
        }
      })
    },
    /**
             * @description 总商户编号输入框获取焦点事件
             */
    handleHeadShopMerchantIdBlur () {
      const data = qs.stringify({ FMerchantId: this.form.headMerchantId })
      this.headShopMerchantIdError = ''
      // 查询总店编号是否有误
      checkMerchantId(data).then(response => {
        // 如果总店编号存在
        if (response.error_code === '0') {
          this.$message({
            message: response.error_msg,
            type: 'success'
          })
          // 如果总店商户id修改过，重置商户入网信息
          if (this.headShopMerchantIdOld !== this.form.headMerchantId) {
            // 如果企业资料选的是总店，先清空内容
            if (this.businessInfoFlag === 1) {
              this.businessInfoMethod(0)
            }
            // 如果结算对象是总店且是进件加盟分店，清空内容
            if (this.bankForm.settleTo === 1 && this.headShopMerchantIdInput) {
              this.bankForm.settleTo = ''
              this.settleToMethod(this.bankForm.settleTo)
            }
            //    查询总店的数据，如果企业资料和结算信息选择总店就可以直接回填
            this.getParentData()
          }
        } else {
          this.headShopMerchantIdError = response.error_msg
          this.$message({
            message: response.error_msg,
            type: 'warning'
          })
        }
        // 保存原来的总店商户id
        this.headShopMerchantIdOld = this.form.headMerchantId
      })
    },
    /**
             * @description 检测账号的可用性
             */
    checkUserName () {
      let userName = this.form.username
      if (userName === '') {
        this.$message({
          message: '请输入登录账号.'
        })
        return false
      }
      userName = qs.stringify({ userName: userName })
      this.checkLoading = true
      this.userNameItemError = ''
      checkUsername(userName).then(data => {
        this.checkLoading = false
        if (data.error_code === '0') {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.userNameItemError = data.error_msg
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    /**
             * @description 切换结算对象触发方法
             * @param {Number} value 0加盟分店，1总店
             */
    settleToMethod (value) {
      const that = this
      if (value === 1) {
        if (JSON.stringify(this.parentData) === '{}') {
          this.$message({
            message: '总店商户不存在或信息获取失败，请核对并重试！',
            type: 'warning'
          })
          return
        }
        const basic = this.parentData.basic
        const pic = this.parentData.pics
        this.needOcr = false
        that.setBankForm(basic, pic, true)
        setTimeout(function () { that.needOcr = true }, 100)
        if (that.businessInfoFlag === 1) {
          that.bankForm.legalFlag = basic.legalFlag
          // 切换至法人结算时，非法人信息清空
        } else {
          that.bankForm.legalFlag = 0
        }
        // that.legalFlagDisabled = true;
        that.settleToHead = true
      } else {
        // that.legalFlagDisabled = false;
        that.settleToHead = false
        that.bankForm = that.$options.data().bankForm
        that.bankForm.settleTo = 0
        // 切换至法人结算时，非法人信息清空
        that.bankForm.nonLegSettleAuthPic = ''
        that.bankForm.nonLegIdcardFrontPic = ''
        that.bankForm.nonLegIdcardBackPic = ''
        setTimeout(function () {
          that.$refs.bankForm.clearValidate()
          that.$refs.bankBranchForm.$refs.form.clearValidate()
        }, 100)
        if (that.businessForm.merchantType === 1) {
          that.wxMchTypeChange(1)
        }
      }
    },
    /**
             * @description 设置账户类型
             * @param {Number} value 1对私账户，2对公账户
             */
    setAccType (value) {
      this.$refs.bankForm.clearValidate('legalFlag')
      this.bankForm.accountType = value
      // 对公账户只能是法人结算，使用法人的信息
      this.bankForm.legalFlag = 1// 法人结算
      if (value === 2) {
        this.bankForm.holder = this.businessForm.licenseFullName
        this.bankForm.bankIdCardType = this.businessForm.credentialType
        this.bankForm.accountIdCardNo = this.businessForm.idCardNo
        // this.legalFlagDisabled = true;//法人或非法人结算不可编辑
        // 对公结算 填充受益人信息
        // this.fillBeneficialInfo(2)
      } else {
        // this.legalFlagDisabled = false;
        if (this.bankForm.legalFlag === 1) {
          this.bankForm.holder = this.businessForm.legalName
          this.bankForm.bankIdCardType = this.businessForm.credentialType
          this.bankForm.accountIdCardNo = this.businessForm.idCardNo
        }
      }
      this.fillBeneficialInfo()
    },
    /**
             * @description 请求总店的数据，如果企业资料和结算信息选择总店就可以直接回填
             */
    getParentData () {
      const that = this
      // const agentId = this.$store.getters.userId
      let param = {
        merchantId: that.form.headMerchantId
        // agentId : agentId
      }
      this.loading = true
      param = qs.stringify(param)
      getMerchantInfo(param).then(data => {
        this.loading = false
        if (data.result_cde === '0') {
          that.parentData = data
          // this.getGroup(that.parentData.basic.fMccType);
        } else {
          that.$message({
            message: data.result_msg,
            type: 'error'
          })
        }
      })
    },
    /**
             * @description 开户号输入框获取焦点事件
             */
    handleBankCardIdBlur () {
      // if (this.bankForm.bankCardNo) this.isBankCardIdLuhmChecked = !luhmCheck(this.bankForm.bankCardNo);
      // if (!this.isBankCardIdLuhmChecked){
      //     this.lumhBankCardId = this.bankForm.bankCardNo
      // }
      if (this.bankForm.bankCardNo && /^\d{16,19}$/.test(this.bankForm.bankCardNo)) {
        this.lumhBankCardId = this.bankForm.bankCardNo
      }
    },

    // 以下为其他信息中的方法
    /**
             * @description 业务类型选择change
             */
    handlePayTypeSelectChange () {
      this.form.reportConfigId = ''
      this.form.subAppid = ''
      this.form.publicsignalAuthorizationDirectory = ''
      this.form.subscribeAppid = ''
    },
    /**
             * @description 代理商微信渠道信选择获取焦点
             */
    handleAgentChannelSelectFocus () {
      this.getAvailableChannel(this.other.fPayType)
    },
    /**
             * @description 代理商微信渠道信选择change
             */
    handleAgentChannelSelectChange (value) {
      this.setWxInfo()
    },
    /**
             * @description 代理商可用微信渠道号查询
             */
    getAvailableChannel (fPayType) {
      return new Promise((resolve, reject) => {
        this.selectLoading = true
        const param = qs.stringify({ fPayType: fPayType })
        getAvailableChannel(param).then(response => {
          this.selectLoading = false
          if (response.error_code === '0') {
            this.agentChannelList = response.data
            resolve()
          } else {
            resolve(false)
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    /**
             * @description 微信公众号支付是否自定义设置Change
             */
    isSelfSetWxInfoChange () {
      this.$refs.otherForm.resetFields()
      this.setWxInfo()
    },
    /**
             * @description 微信公众号支付设置
             */
    setWxInfo () {
      if (this.form.reportConfigId && !this.isSelfSetWxInfo) {
        const selectedInfo = this.agentChannelList.find(element => {
          return element.fId === this.form.reportConfigId
        })
        this.form.subAppid = selectedInfo.fWxSubAppid
        this.form.publicsignalAuthorizationDirectory = selectedInfo.fWxJsapiPath
        this.form.subscribeAppid = selectedInfo.fWxSubscribeAppid
      } else {
        this.form.subAppid = ''
        this.form.publicsignalAuthorizationDirectory = ''
        this.form.subscribeAppid = ''
      }
    },
    /**
             * @description 图片上传成功的回调
             */
    uploadSuccess (data) {
      if (data.error_code === '0') {
        const name = data.valueName
        if (name.includes('.')) {
          this[name.split('.')[0]][name.split('.')[1]] = data.path
          this.$refs[name.split('.')[0]].validateField(name.split('.')[1])
        } else {
          this[name] = data.path
          this.$refs.picForm.validateField(name)
        }
        if (!this.isEdit && !this.readOnly) {
          this.storeToLocal()
        }
      }
    },
    /**
             * @description 读取本地存储数据方法
             */
    async getLocalStorageAddInfo () {
      const storageAddInfo = localStorage.getItem('MERCHANT_ADD_INFO2')
      if (storageAddInfo && storageAddInfo !== 'undefined') {
        await this.$confirm('是否要读取已保存表单数据？', '提示', {
          confirmButtonText: '读取',
          cancelButtonText: '不读取',
          closeOnClickModal: false
        }).then(() => {
          const storageAddInfoObj = JSON.parse(storageAddInfo)
          for (const key in storageAddInfoObj) {
            // eslint-disable-next-line no-prototype-builtins
            if (storageAddInfoObj.hasOwnProperty(key)) {
              this[key] = storageAddInfoObj[key]
            }
          }
          this.needOcr = false
        }).catch(() => {

        })
        this.needOcr = true
        this.resetMccGroup()
        if (this.form.reportConfigId) {
          this.getAvailableChannel(this.other.fPayType)
        }
      }
    },
    /**
             * @description 加载本地数据之后获取行业列表
             */
    resetMccGroup () {
      const mccMiddle = this.businessForm.mccMiddle
      const mccCode = this.businessForm.mccCode
      this.getGroup(this.businessForm.mccType)
      this.businessForm.mccMiddle = mccMiddle
      this.getMccDetails(this.businessForm.mccMiddle)
      this.businessForm.mccCode = mccCode
    },
    /**
             * @description 设置触发对应事件时进行本地存储
             */
    setStoreOnEvent () {
      const eventArr = ['blur', 'change', 'select']
      const self = this
      function getChildrenItem (item) {
        if (item.$el.className && !item.$el.className.includes('el-select') && !item.$el.className.includes('el-input') && !item.$el.className.includes('el-checkbox') && !item.$el.className.includes('el-autocomplete')) {
          item.$children.forEach(element => {
            getChildrenItem(element)
          })
        } else {
          eventArr.forEach(eventStr => {
            item.$on(eventStr, event => {
              self.storeToLocal()
            })
          })
        }
      }
      const refs = this.$refs
      for (const key in refs) {
        // eslint-disable-next-line no-prototype-builtins
        if (refs.hasOwnProperty(key)) {
          if (key === 'accountForm' || key === 'businessForm' || key === 'bankForm' || key === 'picForm' || key === 'otherForm' || key === 'beneficiaryForm') {
            const element = refs[key]
            getChildrenItem(element)
          }
        }
      }
    },
    /**
             * @description 本地存储方法
             */
    storeToLocal () {
      const addInfo = {
        businessInfoFlag: this.businessInfoFlag,
        businessEditable: this.businessEditable,
        form: { ...this.form }, // JSON.parse(JSON.stringify(this.addForm))
        businessForm: { ...this.businessForm },
        bankForm: { ...this.bankForm },
        picForm: { ...this.picForm },
        beneficiaryForm: { ...this.beneficiaryForm },
        other: this.other,
        headShopMerchantIdInput: this.headShopMerchantIdInput,
        subscribeAppidItem: this.subscribeAppidItem,
        subAppidItem: this.subAppidItem,
        publicsignalAuthorizationDirectoryItem: this.publicsignalAuthorizationDirectoryItem,
        settleTypeFlag: this.settleTypeFlag,
        // legalFlagDisabled: this.legalFlagDisabled,
        settleToHead: this.settleToHead,
        parentData: { ...this.parentData },
        licenseExpiryDate: { ...this.licenseExpiryDate },
        idCardExpiryDate: { ...this.idCardExpiryDate },
        beneficiaryExpiryDate: { ...this.beneficiaryExpiryDate }
      }
      addInfo.form.password = ''
      localStorage.setItem('MERCHANT_ADD_INFO2', JSON.stringify(addInfo))
    },
    /**
             * @description 表单校验，提交给父级
             */
    async submit () {
      if (this.businessForm.merchantType !== 3 && this.businessForm.merchantName.includes('公司')) {
        this.$message({
          message: '商户全称包含“公司”，商户类型请选择企业',
          type: 'warning'
        })
        return
      }
      if (!this.checkFormInfo()) return
      let picArr = []
      if (this.picForm.otherPics) {
        picArr = this.picForm.otherPics.split(',')
      }
      const picData = {}
      picArr.map((value, index) => {
        picData[`pic${index + 1}`] = value
        return value
      })
      const data = Object.assign({}, this.form, this.businessForm, this.bankForm, this.otherForm, this.picForm, this.beneficiaryForm)
      data.otherPics = JSON.stringify(picData)

      if (this.bankTypeError) {
        await this.$confirm('卡号与开户行不匹配，是否确认提交？', '提示', {}).then(() => {
        })
      }
      this.$emit('submit', data)
    },
    /**
             * @description 校验表单信息
             */
    checkFormInfo () {
      let accountFormValid = false
      let businessInfoFormValid = false
      let bankFormValid = false
      let beneficiaryFormValid = false
      let otherFormValid = false
      let picFormValid = false
      let bankBranchFormValid = false// 银行网点组件校验
      let addressSelectFormValid = false// 经营地址组件校验
      let licenseDateValid = false
      let idcardDareValid = false
      let beneficiaryExpiryDate = false
      this.$refs.accountForm.validate((valid) => {
        accountFormValid = valid
        return valid
      })
      this.$refs.addressSelectForm.$refs.form.validate((valid) => {
        addressSelectFormValid = valid
        return valid
      })
      this.$refs.businessForm.validate((valid) => {
        businessInfoFormValid = valid
        return valid
      })
      this.$refs.bankBranchForm.$refs.form.validate((valid) => {
        bankBranchFormValid = valid
        return valid
      })
      this.$refs.bankForm.validate((valid) => {
        bankFormValid = valid
        return valid
      })
      this.$refs.beneficiaryForm.validate((valid) => {
        beneficiaryFormValid = valid
        return valid
      })
      this.$refs.otherForm.validate((valid) => {
        otherFormValid = valid
        return valid
      })
      this.$refs.picForm.validate((valid) => {
        picFormValid = valid
        return valid
      })
      this.$refs.licenseExpiryDate.$refs.form.validate((valid) => {
        licenseDateValid = valid
        return valid
      })
      this.$refs.idCardExpiryDate.$refs.form.validate((valid) => {
        idcardDareValid = valid
        return valid
      })
      this.$refs.beneficiaryExpiryDate.$refs.form.validate((valid) => {
        beneficiaryExpiryDate = valid
        return valid
      })
      if (!accountFormValid || !licenseDateValid || !idcardDareValid) {
        this.$message({
          message: '商户账户信息有误或不完整，请完善相关信息',
          type: 'warning'
        })
        return false
      }
      if (!businessInfoFormValid || !addressSelectFormValid) {
        this.$message({
          message: '商户入网信息有误或不完整，请完善相关信息',
          type: 'warning'
        })
        return false
      }
      if (!bankFormValid || !bankBranchFormValid) {
        this.$message({
          message: '商户结算信息有误或不完整，请完善相关信息',
          type: 'warning'
        })
        return false
      }
      if (!beneficiaryFormValid || !beneficiaryExpiryDate) {
        this.$message({
          message: '受益所有人信息有误或不完整，请完善相关信息',
          type: 'warning'
        })
        return false
      }
      if (!otherFormValid) {
        this.$message({
          message: '其他信息有误或不完整，请完善相关信息',
          type: 'warning'
        })
        return false
      }
      if (!picFormValid) {
        this.$message({
          message: '证照信息有误或不完整，请完善相关信息',
          type: 'warning'
        })
        return false
      }
      return true
    },
    /**
             * @description 查看或编辑时获取初始信息
             */
    getDetailsInfo () {
      let data = {
        merchantId: this.id
      }
      const that = this
      data = qs.stringify(data)
      this.loading = true
      getMerchantInfo(data).then(data => {
        this.needOcr = false
        this.refresh = false
        if (parseInt(data.result_cde) !== 0) {
          this.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        } else {
          const basic = data.basic
          const pic = data.pics
          const otherPicArr = []
          const otherPicArrPath = []
          if (basic.statusDesc === '审核通过' || basic.statusDesc === '待审核') {
            this.ifHide = true
          } else {
            this.ifHide = false
          }
          this.form.shopType = basic.shopType
          if (this.form.shopType === 0 || this.form.shopType === 2) {
            that.headShopMerchantIdInput = true
          } else {
            that.headShopMerchantIdInput = false
          }
          this.form.fNopassReason = basic.fNopassReason || ''
          this.form.headMerchantId = basic.headShopMerchantId || ''
          this.form.username = basic.fUserName || ''
          this.form.mobile = this.ifHide ? hidePhoneNum(basic.fMobile) : basic.fMobile || ''
          this.form.notifyAddress = basic.notifyAddress || ''

          this.form.reportConfigId = basic.reportConfigId || ''
          this.form.subscribeAppid = basic.subscribeAppid || ''
          this.form.subAppid = basic.subAppid || ''
          this.form.publicsignalAuthorizationDirectory = basic.publicsignalAuthorizationDirectory || ''
          this.form.wxCategory = basic.wxCategory || ''
          this.form.wxMchName = basic.wxMchName || ''
          this.form.auditCallback = basic.auditCallback || ''

          this.setBusinessForm(basic, pic)
          this.bankForm.settleTo = basic.settleTo

          this.setBankForm(basic, pic)
          // 赋值受益人信息
          this.setBeneficiailForm(basic)
          this.other.fPayType = basic.fPayType
          this.fAgentId = this.$store.getters.userId

          this.form.statusDesc = basic.statusDesc || ''
          this.form.statusId = basic.state || ''

          if (![-1, 3, 1].includes(this.form.statusId)) {
            this.$emit('resetDisabled', true)
          }

          if (this.form.statusDesc === '审核不通过') {
            this.remark = basic.failReason || ''
          }
          for (let i = 1; i <= 20; i++) {
            pic[`pic${i}Url`] && otherPicArr.push(pic[`pic${i}Url`])
            pic[`pic${i}`] && otherPicArrPath.push(pic[`pic${i}`])
          }
          this.picForm.otherPics = otherPicArr.join(',')
          this.picForm.otherPicsPath = otherPicArrPath.join(',')
          //    位置变化的属性赋值
          if (this.isEdit) {
            this.picForm.insidePic = pic.businessInsideUrl || ''
            this.picForm.doorPic = pic.doorPhotoUrl || ''
            this.picForm.cashierDeskPic = pic.cashierDeskUrl || ''
            this.picForm.agreementPic = pic.agreementPicUrl || ''
          } else {
            this.picForm.insidePic = pic.businessInside || ''
            this.picForm.doorPic = pic.doorPhoto || ''
            this.picForm.cashierDeskPic = pic.cashierDesk || ''
            this.picForm.agreementPic = pic.agreementPic || ''
          }
          if (this.isEdit) {
            this.notPassed = (this.form.statusDesc === '审核不通过')
            this.passed = (this.form.statusDesc === '审核通过')
            this.toFinish = (this.form.statusDesc === '资料待完善')
          }
          // 编辑商户且为分店
          if (this.isEdit && this.form.headMerchantId) {
            this.getParentData()
          }
          this.contactInfo.contactPhoneNo = basic.contactPhoneNo
          this.contactInfo.contactIdCard = basic.contactIdCard
          this.contactInfo.contactName = basic.contactName
        }
        setTimeout(function () {
          that.needOcr = true
          that.loading = false
        }, 100)
      })
    },
    /**
             * @description 有效期赋值
             * @param {Object} value 结果对象
             */
    getExpiryDate (value) {
      const start = value.valueName + 'Start'
      const end = value.valueName + 'End'
      this.businessForm[start] = value.dateStart
      this.businessForm[end] = value.longTermTag ? '2099-12-30' : value.dateEnd
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    /**
             * @description 受益人有效期赋值
             * @param {Object} value 结果对象
             */
    getBeneficiaryExpiryDate (value) {
      const start = value.valueName + 'Start'
      const end = value.valueName + 'End'
      this.beneficiaryForm[start] = value.dateStart
      this.beneficiaryForm[end] = value.longTermTag ? '2099-12-30' : value.dateEnd
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    // orc识别数据回填
    getOCRResult (data) {
      if (data.success) {
        switch (data.valueName) {
          case 'businessForm.licensePic': {
            // 营业执照
            this.businessForm.licenseFullName = data.name
            this.businessForm.merchantName = data.name
            this.businessForm.license = data.licenseNo
            let start, end
            if (data.period.includes('长期') || data.period.includes('不约定期限') || data.period.includes('永久')) {
              start = data.period.includes('至') ? this.formatDate(data.period.split('至')[0]) : ''
              end = '2099-12-30'
            } else {
              start = this.formatDate(data.period.split('至')[0])
              end = data.period.split('至')[1]
              end = this.formatDate(end)
            }
            this.licenseExpiryDate.dateStart = start
            this.licenseExpiryDate.dateEnd = end === '2099-12-30' ? '' : end
            this.licenseExpiryDate.longTermTag = end === '2099-12-30'
            break
          }
          case 'businessForm.idcardFrontPic': {
            // 身份证人像面
            this.businessForm.legalName = data.name
            this.businessForm.idCardNo = data.idcard
            break
          }
          case 'businessForm.idcardBackPic': {
            // 身份证国徽面
            const start = this.formatDate(data.validDate.split('-')[0])
            const end = this.formatDate(data.validDate.split('-')[1])
            this.idCardExpiryDate.dateStart = start
            this.idCardExpiryDate.dateEnd = end === '2099-12-30' ? '' : end
            this.idCardExpiryDate.longTermTag = end === '2099-12-30'
            break
          }
          case 'bankForm.nonLegIdcardFrontPic': {
            // 非法人身份证人像面
            this.bankForm.holder = data.name
            this.bankForm.accountIdCardNo = data.idcard
            this.beneficiaryForm.beneficiaryName = data.name
            this.beneficiaryForm.beneficiaryCertificateNo = data.idcard
            this.beneficiaryForm.beneficiaryAddress = data.address
            break
          }
          case 'bankForm.nonLegIdcardBackPic': {
            // 非法人身份证国徽面
            const start = this.formatDate(data.validDate.split('-')[0])
            const end = this.formatDate(data.validDate.split('-')[1])
            this.beneficiaryExpiryDate.dateStart = start
            this.beneficiaryExpiryDate.dateEnd = ['2099-12-30', '长期'].includes(end) ? '' : end
            this.beneficiaryExpiryDate.longTermTag = ['2099-12-30', '长期'].includes(end)
            break
          }
          case 'bankForm.bankCardFrontPic': {
            this.bankForm.bankCardNo = data.bankcardNo
            this.$refs.bankForm.validateField('bankCardNo')
            this.handleBankCardIdBlur()
            this.bankForm.FBankTypeCode = ''
            this.bankForm.FBankAreaCode = ''
            this.bankForm.FBankCityCode = ''
            this.bankForm.unionpay = ''
            break
          }
        }
      }
      // 保存上传的图片
      const name = data.valueName
      if (name.includes('.')) {
        this[name.split('.')[0]][name.split('.')[1]] = data.path
        this.$refs[name.split('.')[0]].validateField(name.split('.')[1])
      } else {
        this[name] = data.path
        this.$refs.picForm.validateField(name)
      }
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    },
    // 日期格式转换，含有年月日或纯数字，转换成-
    formatDate (str) {
      // ocr识别出错兼容
      if (!str || str === '无') {
        return ''
      }
      try {
        if (str.includes('年')) {
          const year = str.split('年')[0].trim()
          const month = str.split('年')[1].split('月')[0].trim()
          const day = str.split('年')[1].split('月')[1].split('日')[0].trim()
          return year + '-' + month + '-' + day
        } else if (str.length >= 8) {
          const year = str.substr(0, 4)
          const month = str.substr(4, 2)
          const day = str.substr(6, 2)
          return year + '-' + month + '-' + day
        } else {
          return ''
        }
      } catch (error) {
        console.log(error)
        return ''
      }
    },
    wxMchTypeChange (value) {
      if (value > 2 && this.businessForm.merchantType === 3) {
        this.businessForm.merchantType = 3
        this.businessForm.companyChildType = value - 2
        return
      }
      if (value === 1) {
        this.businessForm.licenseFlag = true
        this.resetLicense()
        this.credentialType = 1
        this.bankForm.accountType = 1
        this.bankForm.legalFlag = 1
        this.setAccType(1)
        this.businessForm.merchantType = 1
        this.businessForm.companyChildType = ''
      } else {
        this.businessForm.licenseFlag = false
        this.bankForm.accountType = ''
        this.bankForm.legalFlag = ''
        this.businessForm.merchantName = ''
        if (value >= 3) {
          this.businessForm.merchantType = 3
          this.businessForm.companyChildType = value - 2
        } else {
          this.businessForm.merchantType = 2
        }
      }
    },
    // 根据联行号查出银行信息
    getInfoByUnion (code) {
      const that = this
      const data = qs.stringify({
        unionpayCode: code
      })
      findBranch(data).then(response => {
        if (parseInt(response.result_cde) === 0) {
          const data = response.data
          this.bankForm.FBankTypeCode = data.finInstitutionCode
          this.bankForm.FBankAreaCode = data.cftAreaCode
          this.bankForm.FBankCityCode = data.cftCityCode
          this.bankForm.unionpay = data.unionpayCode
        } else {
          that.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    },
    // 赋值入网信息
    setBusinessForm (basic, pic) {
      const that = this
      that.businessForm.merchantType = basic.fMerchantType === undefined ? '' : basic.fMerchantType
      that.businessForm.companyChildType = basic.companyChildType === undefined ? '' : basic.companyChildType
      that.businessForm.realMerchantType = basic.companyChildType === undefined ? that.businessForm.merchantType : that.businessForm.merchantType + basic.companyChildType - 1
      that.businessForm.legalName = this.ifHide ? hideRealName(basic.fApplicant) : basic.fApplicant || ''
      that.businessForm.credentialType = basic.fCredentialType === undefined ? '' : basic.fCredentialType
      that.businessForm.idCardNo = this.ifHide && [1, 2].includes(that.businessForm.credentialType) ? hideIdCardNum(basic.fIdcard) : basic.fIdcard || ''
      that.businessForm.merchantName = basic.licenseFullName || ''
      that.businessForm.merchantShortName = basic.fMerchantName || ''
      that.businessForm.licenseType = basic.licenseType
      that.businessForm.licenseFullName = basic.fBusinessLicenseName || ''
      that.businessForm.mccType = basic.fMccGrandpaCode
      that.businessForm.mccMiddle = basic.fMccFatherCode
      that.businessForm.mccCode = basic.mccCode
      that.businessForm.servicePhone = this.ifHide ? hidePhoneNum(basic.fServicePhone) : basic.fServicePhone || ''
      that.businessForm.license = basic.fLicense || ''
      if (!that.businessForm.license && that.businessForm.merchantType === 1) {
        that.businessForm.licenseFlag = true
      } else {
        that.businessForm.licenseFlag = false
      }
      that.businessForm.provinceCode = basic.provinceCode
      that.businessForm.cityCode = basic.cityCode
      that.businessForm.areaCode = basic.areaCode
      that.businessForm.address = basic.fAddress || ''

      that.businessForm.idCardStart = basic.fIdcardStart
      that.businessForm.idCardEnd = basic.fIdcardEnd
      that.businessForm.licenseStart = basic.fLicenseStart
      that.businessForm.licenseEnd = basic.fLicenseEnd
      // 两个有效期赋值
      that.licenseExpiryDate.dateStart = basic.fLicenseStart
      that.licenseExpiryDate.dateEnd = ['2099-12-30', '长期', '永久', '不约定期限'].includes(basic.fLicenseEnd) ? '' : basic.fLicenseEnd
      that.licenseExpiryDate.longTermTag = ['2099-12-30', '长期', '永久', '不约定期限'].includes(basic.fLicenseEnd)

      that.idCardExpiryDate.dateStart = basic.fIdcardStart
      that.idCardExpiryDate.dateEnd = (basic.fIdcardEnd === '2099-12-30' || basic.fIdcardEnd === '长期') ? '' : basic.fIdcardEnd
      that.idCardExpiryDate.longTermTag = (basic.fIdcardEnd === '2099-12-30' || basic.fIdcardEnd === '长期')

      if (!that.readOnly) {
        that.businessForm.licensePic = pic.businessLicenseCUrl || ''
        that.businessForm.idcardFrontPic = pic.idcardFrontUrl || ''
        that.businessForm.idcardBackPic = pic.idcardBackUrl || ''
      } else {
        that.businessForm.licensePic = pic.businessLicenseC || ''
        that.businessForm.idcardFrontPic = pic.idcardFront || ''
        that.businessForm.idcardBackPic = pic.idcardBack || ''
      }
      this.resetMccGroup()
    },
    // 赋值结算信息
    setBankForm (basic, pic, settleChange) {
      const that = this
      that.bankForm.accountType = basic.accountType === undefined ? '' : basic.accountType
      that.bankForm.legalFlag = basic.legalFlag === undefined ? '' : basic.legalFlag
      that.bankForm.holder = this.ifHide ? hideRealName(basic.fBankHolder) : basic.fBankHolder || ''
      that.bankForm.accountIdCardNo = this.ifHide ? hideIdCardNum(basic.bankIdCard) : basic.bankIdCard || ''
      that.bankForm.bankCardNo = this.ifHide ? hideBankCardNum(basic.fBankAccount) : basic.fBankAccount || ''
      if (basic.fBankNameCode && basic.fBankNameCode.includes('C')) {
        that.bankForm.FBankTypeCode = basic.fBankNameCode
        // that.bankForm.FBankTypeCode = 'C1284443000014';
        that.bankForm.FBankAreaCode = basic.fBankProvinceCode
        that.bankForm.FBankCityCode = basic.fBankCityCode
        that.bankForm.unionpay = basic.fUnionpayCode
      } else if (basic.fBankNameCode) {
        that.getInfoByUnion(basic.fUnionpayCode)
      }
      that.bankForm.accountMobile = this.ifHide ? hidePhoneNum(basic.fBankcardPhone) : basic.fBankcardPhone
      if (this.isEdit || settleChange) {
        that.bankForm.nonLegSettleAuthPic = pic.nonLegSettleAuthUrl || ''
        that.bankForm.nonLegIdcardFrontPic = pic.nonLegIdcardFrontUrl || ''
        that.bankForm.nonLegIdcardBackPic = pic.nonLegIdcardBackUrl || ''
        that.bankForm.bankCardFrontPic = pic.bankcardFrontUrl || ''
      } else {
        that.bankForm.nonLegSettleAuthPic = pic.nonLegSettleAuth || ''
        that.bankForm.nonLegIdcardFrontPic = pic.nonLegIdcardFront || ''
        that.bankForm.nonLegIdcardBackPic = pic.nonLegIdcardBack || ''
        that.bankForm.bankCardFrontPic = pic.bankcardFront || ''
      }
      if (that.bankForm.legalFlag === 1) {
        that.bankForm.bankIdCardType = that.businessForm.credentialType
      } else {
        that.bankForm.bankIdCardType = 1
      }
    },
    getNewMobile (value) {
      this.form.mobile = this.ifHide ? hidePhoneNum(value) : value || ''
    },
    // 获取营业执照名称，复制给商户全称
    getLicenseInput (e) {
      this.businessForm.merchantName = e.target.value
    },
    // 获取地址
    getaddresstxt (data) {
      this.adTxt = data
      localStorage.setItem('addTxt', this.adTxt)
      if (this.businessForm.merchantType === 1) {
        this.fillBeneficialInfo()
      }
    },
    // 对公结算时 填充法人信息到受益人信息
    fillBeneficialInfo () {
      switch (this.bankForm.accountType) {
        case 1: // 对私
          this.privateBeneficial()
          break
        case 2: // 对公
          this.publicBeneficial()
          break
      }
    },
    // 对公结算 法人/非法人
    publicBeneficial () {
      this.beneficiaryForm.beneficiaryName = JSON.parse(JSON.stringify(this.businessForm.legalName))
      this.beneficiaryForm.beneficiaryCertificateType = this.businessForm.credentialType
      this.beneficiaryForm.beneficiaryCertificateNo = JSON.parse(JSON.stringify(this.businessForm.idCardNo))
      this.beneficiaryExpiryDate = { ...this.idCardExpiryDate }
      this.beneficiaryForm.beneficiaryAddress = this.adTxt ? this.adTxt : localStorage.getItem('addTxt')
    },
    // 对私结算
    privateBeneficial () {
      // 法人
      if (this.bankForm.legalFlag === 1) {
        this.publicBeneficial()
      } else if (this.bankForm.legalFlag === 0) {
        // 非法人
        this.beneficiaryForm.beneficiaryName = JSON.parse(JSON.stringify(this.bankForm.holder))
        this.beneficiaryForm.beneficiaryCertificateType = 1
        this.beneficiaryForm.beneficiaryCertificateNo = JSON.parse(JSON.stringify(this.bankForm.accountIdCardNo))
        this.beneficiaryExpiryDate = {}
        this.beneficiaryForm.beneficiaryAddress = this.adTxt ? this.adTxt : localStorage.getItem('addTxt')
        setTimeout(() => {
          this.$refs.beneficiaryExpiryDate.$refs.form.clearValidate()
        }, 150)
      }
    },
    // 对私结算 非法人
    clearInfo () {
      if (this.bankForm.accountType === 1) {
        if (this.bankForm.legalFlag === 0) {
          this.beneficiaryForm = {
            beneficiaryName: '',
            beneficiaryCertificateType: 1,
            beneficiaryCertificateNo: '',
            beneficiaryValidityStart: '',
            beneficiaryValidityEnd: ''
            // beneficiaryAddress:''
          }
          this.beneficiaryExpiryDate = {
            dateStart: '',
            dateEnd: '',
            longTermTag: false
          }
          setTimeout(() => {
            this.$refs.beneficiaryExpiryDate.$refs.form.clearValidate()
          }, 150)
        } else {
          this.publicBeneficial()
        }
      }
    },
    // 赋值受益人信息
    setBeneficiailForm (basic) {
      this.beneficiaryForm.beneficiaryName = basic.beneficiaryName
      this.beneficiaryForm.beneficiaryCertificateType = basic.beneficiaryCertificateType
      this.beneficiaryForm.beneficiaryCertificateNo = basic.beneficiaryCertificateNo
      this.beneficiaryForm.beneficiaryAddress = basic.beneficiaryAddress
      this.beneficiaryExpiryDate.dateStart = basic.beneficiaryValidityStart
      this.beneficiaryExpiryDate.dateEnd = ['2099-12-30', '长期', '永久', '不约定期限'].includes(basic.beneficiaryValidityEnd) ? '' : basic.beneficiaryValidityEnd
      this.beneficiaryExpiryDate.longTermTag = ['2099-12-30', '长期', '永久', '不约定期限'].includes(basic.beneficiaryValidityEnd)
      setTimeout(() => {
        this.$refs.beneficiaryExpiryDate.$refs.form.clearValidate()
      }, 150)
    },
    // 批量上传成功回调
    multiUploaded (data) {
      if (this.picForm[data.valueName] === '') {
        this.picForm[data.valueName] += data.path
      } else {
        this.picForm[data.valueName] += ',' + data.path
      }
    },
    // 批量上传删除某一张回调
    multiDelete (data) {
      if (this.picForm[data.valueName].indexOf(',' + data.path) >= 0) {
        this.picForm[data.valueName] = this.picForm[data.valueName].replace(',' + data.path, '')
      } else {
        this.picForm[data.valueName] = this.picForm[data.valueName].replace(data.path, '')
      }
      if (this.picForm[data.valueName].indexOf(',') === 0) {
        this.picForm[data.valueName] = this.picForm[data.valueName].substring(1)
      }
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .red label{
        color: red;
    }
    .form-input {
        width: 450px;
    }
    .form-flex-item {
        margin-right: 5px;
    }
    .form-tip-label {
      margin: 0;
      color:#D49B5F;
      vertical-align:middle;
      display:inline-block;
      font-size:14px;
      font-family:Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
    }
    .file-download-button {
        color: #409eff;
        margin: 0 10px;
    }
    .report-config-id-tip-view {
        margin: 10px 100px;
        color: #606266;
        font-size: 14px;
    }
    @mixin flex-horizontal {
        display: -webkit-box;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .is-participate-view {
        @include flex-horizontal;
            margin-bottom: 10px;
        .is-participate-view-title {
            margin-right: 30px;
        }
    }
    .report-config-id-tip-view {
        margin: 10px 100px;
        color: #606266;
        font-size: 14px;
    }
    .merchant-info-head-view {
        @include flex-horizontal;
        justify-content: space-between;
        .merchant-info-title-view {
            flex: 1;
        }
        .merchant-info-batch-import-view {
            .merchant-info-batch-import-buttons {
                @include flex-horizontal;
            }
            .new-file-tip {
                font-size: 14px;
                margin: 5px 0;
            }
            .new-file-name {
                font-size: 14px;
            }
        }
    }
    .photos-content-view {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
    }
    .photos-content-view .el-form-item{
        margin-right: 40px;
        width: 200px;
        text-align: center;
    }
    .changePhone{
        position: absolute;
        left: 600px;
    }
    .submitBtn{
        display: block;
        margin: 20px auto;
    }
    .flexRow .el-form-item{
        width: 150px;
    }
    .statusDiv{
        margin: 10px 0;
    }
    .status{
        height: 30px;
        line-height: 30px;
        border-radius: 50px;
        padding: 0 15px;
        color: #fff;
        font-size: 13px;
        display: inline-block;
    }
    .status i{
        margin-right: 5px;
    }
    .status.red{
        background: #ff7070;
    }
    .status.green{
        background: #77d580;
    }
    .status.gray{
        background: #a7a7a7;
    }
    .reviewTime{
        line-height: 30px;
        height: 30px;
        display: inline-block;
        font-size: 14px;
        color: #727272;
    }
    p.form-tip-label{
      display: block;
    }
    .contactItem {
      margin-bottom: 10px;
    }
    .contactItem:last-child {
      margin-bottom: 0;
    }
    .contactLabel {
      width: 50px;
      margin-right: 10px;
      display: inline-block;
    }
</style>
<style>
.el-collapse-item__arrow {
    margin: 0 8px 0 10px;
}
.el-collapse-item__wrap{
    border:none
}
.el-divider--horizontal{
    margin:10px 0
}
</style>
